import { Action } from '@ngrx/store';
import { ChartInfo } from '../chart-info.model';


export const SET_CHARTS = 'SET_CHARTS';
export const FETCH_CHARTS = 'FETCH_CHARTS';

export class SetCharts implements Action {
  readonly type = SET_CHARTS;

  constructor(public payload: ChartInfo[]) {}
}

export class FetchCharts implements Action {
  readonly type = FETCH_CHARTS;

  constructor(public payload: string) {}
}

export type ReportActions = SetCharts |
  FetchCharts;



// WEBPACK FOOTER //
// ./src/app/report/store/report.actions.ts